import z from 'zod'

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  INACTIVE = 'INACTIVE',
}

export enum UserType {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  MEMBERS = 'MEMBERS',
}

export const userModel = z.object({
  __typename: z.literal('User').default('User'),
  id: z.string(),
  personId: z.string(),
  email: z.string().email(),
  subId: z.string().nullable(),
  lastPasswordChangeAt: z.string().datetime().nullable(),
  isUserFirstLogin: z.boolean(),
  changePasswordOnNextLogin: z.boolean(),
  userType: z.nativeEnum(UserType),
  isActive: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
})

export type UserModel = z.infer<typeof userModel>
